import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { keyChangeServices } from '../../_services/key-change.services';
import { Router } from "@angular/router";
import { LoginManager } from 'src/app/_managers/login-manager.services';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-spassword',
  templateUrl: './spassword.component.html',
  styleUrls: ['./spassword.component.scss']
})
export class SpasswordComponent implements OnInit {
  keyChange: UntypedFormGroup = new UntypedFormGroup(
    {
      passwordNewConf: new UntypedFormControl('', [Validators.required]),
      passwordNew: new UntypedFormControl('', [Validators.required])
    }
  );
  changeService: keyChangeServices;
  router: Router;
  hideNew = true;
  hideNewConf = true;
  hidep = true;
  codinter = '';

  constructor(private LoginManager: LoginManager, private rutaActiva: ActivatedRoute) { }

  ngOnInit(): void {
    this.rutaActiva.params.subscribe(
      (params: Params) => {
        this.codinter = this.rutaActiva.snapshot.params.codinter;
      }
    );
  }

  change() {
    this.LoginManager.keyChangeOlvidoC(
      this.codinter,  this.keyChange.value.passwordNew,
      this.keyChange.value.passwordNewConf);
  }

}
